import Immutable from "immutable";
import moment from "moment";

const LOAD = "farmLeaseCashCrp/LOAD";
const LOAD_SUCCESS = "farmLeaseCashCrp/LOAD_SUCCESS";
const LOAD_FAIL = "farmLeaseCashCrp/LOAD_FAIL";
const LOAD_ADD_SUCCESS = "farmLeaseCashCrp/LOAD_ADD_SUCCESS";
const LOAD_UPDATE_SUCCESS = "farmLeaseCashCrp/LOAD_UPDATE_SUCCESS";

const CRP_LOAD_SUCCESS = "farmLeaseCashCrp/CRP_LOAD_SUCCESS";
const CRP_LOAD_FAIL = "farmLeaseCashCrp/CRP_LOAD_FAIL";
const CRP_LOAD_ADD_SUCCESS = "farmLeaseCashCrp/CRP_LOAD_ADD_SUCCESS";
const CRP_LOAD_UPDATE_SUCCESS = "farmLeaseCashCrp/CRP_LOAD_UPDATE_SUCCESS";

const CRP_CASH_LOAD_SUCCESS = "farmLeaseCashCrp/CRP_CASH_LOAD_SUCCESS";
const CRP_CASH_LOAD_FAIL = "farmLeaseCashCrp/CRP_CASH_LOAD_FAIL";
const CRP_CASH_LOAD_ADD_SUCCESS = "farmLeaseCashCrp/CRP_CASH_LOAD_ADD_SUCCESS";
const CRP_CASH_LOAD_UPDATE_SUCCESS = "farmLeaseCashCrp/CRP_CASH_LOAD_UPDATE_SUCCESS";

const LEASE_LOAD_SUCCESS = "farmLeaseCashCrp/CRP_LOAD_SUCCESS";
const LEASE_LOAD_FAIL = "farmLeaseCashCrp/CRP_LOAD_FAIL";
const LEASE_LOAD_ADD_SUCCESS = "farmLeaseCashCrp/CRP_LOAD_ADD_SUCCESS";
const LEASE_LOAD_UPDATE_SUCCESS = "farmLeaseCashCrp/CRP_LOAD_UPDATE_SUCCESS";

const LEASE_CASH_LOAD_SUCCESS = "farmLeaseCashCrp/CRP_CASH_LOAD_SUCCESS";
const LEASE_CASH_LOAD_FAIL = "farmLeaseCashCrp/CRP_CASH_LOAD_FAIL";
const LEASE_CASH_LOAD_ADD_SUCCESS = "farmLeaseCashCrp/CRP_CASH_LOAD_ADD_SUCCESS";
const LEASE_CASH_LOAD_UPDATE_SUCCESS = "farmLeaseCashCrp/CRP_CASH_LOAD_UPDATE_SUCCESS";

const CREATE_LEASE_LCC = "farm/CREATE_LEASE_LCC";
const CREATE_LEASE_LCC_SUCCESS = "farm/CREATE_LEASE_LCC_SUCCESS";
const CREATE_LEASE_LCC_FAIL = "farm/CREATE_LEASE_LCC_FAIL";

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  leaseCashCrpData: null,
  farmCrpCashData: null,
  farmLeaseData: null,
  farmLeaseCashData: null,
  loading: false,

  leaseCashRent: {},
  farmCrpData: {},
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_FAIL:
      return state.set("isLoad", false).set("loadErr", action.error).set("farmLeaseCashCrp", null);

    case LOAD_SUCCESS:
      return state.set("isLoad", false).set("leaseCashRent", action.leaseCashRent);

    case LOAD_ADD_SUCCESS:
      return state.set("isLoad", false).set("farmLeaseCashCrp", action.result);

    case LOAD_UPDATE_SUCCESS:
      return state.set("isLoad", false).set("farmLeaseCashCrp", action.farmLeaseCashCrp);

    case CRP_LOAD_FAIL:
      return state.set("isLoad", false).set("loadErr", action.error).set("farmCrpData", null);

    case CRP_LOAD_SUCCESS:
      return state.set("isLoad", false).set("farmCrpData", action.farmCrpData);

    case CRP_LOAD_ADD_SUCCESS:
      return state.set("isLoad", false).set("farmCrpData", action.result);

    case CRP_LOAD_UPDATE_SUCCESS:
      return state.set("isLoad", false).set("farmCrpData", action.farmLeaseCashCrp);

    case CRP_CASH_LOAD_FAIL:
      return state.set("isLoad", false).set("loadErr", action.error).set("farmCrpCashData", null);

    case CRP_CASH_LOAD_SUCCESS:
      return state.set("isLoad", false).set("farmCrpCashData", action.farmCrpCashData);

    case CRP_CASH_LOAD_ADD_SUCCESS:
      return state.set("isLoad", false).set("farmCrpCashData", action.result);

    case CRP_CASH_LOAD_UPDATE_SUCCESS:
      return state.set("isLoad", false).set("farmCrpCashData", action.farmCrpCashData);

    case LEASE_LOAD_FAIL:
      return state.set("isLoad", false).set("loadErr", action.error).set("farmLeaseData", null);

    case LEASE_LOAD_SUCCESS:
      return state.set("isLoad", false).set("farmLeaseData", action.farmLeaseData);

    case LEASE_LOAD_ADD_SUCCESS:
      return state.set("isLoad", false).set("farmLeaseData", action.result);

    case LEASE_LOAD_UPDATE_SUCCESS:
      return state.set("isLoad", false).set("farmLeaseData", action.farmLeaseData);

    case LEASE_CASH_LOAD_FAIL:
      return state.set("isLoad", false).set("loadErr", action.error).set("farmLeaseCashData", null);

    case LEASE_CASH_LOAD_SUCCESS:
      return state.set("isLoad", false).set("farmLeaseCashData", action.farmCrpCashData);

    case LEASE_CASH_LOAD_ADD_SUCCESS:
      return state.set("isLoad", false).set("farmCrpCashData", action.result);

    case LEASE_CASH_LOAD_UPDATE_SUCCESS:
      return state.set("isLoad", false).set("farmLeaseCashData", action.farmCrpCashData);

    case CREATE_LEASE_LCC:
      return state.set("loading", true);

    case CREATE_LEASE_LCC_FAIL:
      return state.set("loading", false).set("errorMessage", action.errorMessage);

    case CREATE_LEASE_LCC_SUCCESS:
      return state.set("loading", false).set("createLeaseLcc", action.createLeaseLcc);

    default:
      return state;
  }
}

export const getLeaseDataByFarmId = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get("/farmLeaseCashCrpTab/getLeaseData/" + id);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const list = res.map((item) => {
      item.commences = item.commences ? moment.utc(item.commences).format("MM/DD/YYYY") : "";
      item.expires = item.expires ? moment.utc(item.expires).format("MM/DD/YYYY") : "";
      if (item.farm_lease_cash_rent_data && item.farm_lease_cash_rent_data.length > 0) {
        item.farm_lease_cash_rent_data = item.farm_lease_cash_rent_data.map((rent) => Object.assign({}, rent, {
          cashRentDue: rent.cashRentDue ? moment.utc(rent.cashRentDue).format("MM/DD/YYYY") : "",
          cashRentPaid: rent.cashRentPaid ? moment.utc(rent.cashRentPaid).format("MM/DD/YYYY") : "",
        }));
      }
      return item;
    });
    const sortedList = list.sort((a, b) => {
      const fromYear = moment(b.commences).year();
      const toYear = moment(a.commences).year();
      return Number(fromYear) - Number(toYear);
    });
    dispatch({ type: LOAD_SUCCESS, leaseCashRent: { data: sortedList } });
    return sortedList;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const addNewLease = (farmId) => async (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const leaseCashRent = getState().get("farmLeaseCashCrp").get("leaseCashRent");
    const data = leaseCashRent.data;

    data.splice(0, 0, { farm_id: farmId, farm_lease_cash_rent_data: [] });

    dispatch({ type: LOAD_SUCCESS, leaseCashRent: { data: data } });
    resolve(data);
  });

export const deleteLease = (id, index) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let leftLeases = [];
  const leaseCashRent = getState().get("farmLeaseCashCrp").get("leaseCashRent");
  const list = leaseCashRent.data;
  try {
    if (id) {
      const data = { id: id };
      const res = await api.del("/farmLeaseCashCrpTab/deleteLeaseData/", { data });
      if (res.message) {
        dispatch({ type: LEASE_LOAD_FAIL, errorMessage: res.message });
        return;
      }
      leftLeases = list.filter((item) => item.id !== id);
    } else {
      leftLeases = list.filter((item, key) => key !== index);
    }
    dispatch({ type: LOAD_SUCCESS, leaseCashRent: { data: leftLeases } });
    return leftLeases;
  } catch (error) {
    dispatch({ type: LEASE_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const deleteLeasecashData = (cashRentId) => async (dispatch, getState, api) => {
  const leaseCashRent = getState().get("farmLeaseCashCrp").get("leaseCashRent");
  const leases = leaseCashRent.data;

  dispatch({ type: LOAD });
  try {
    const data = { id: cashRentId };
    const res = await api.del("/farmLeaseCashCrpTab/leaseCash/delete/", { data });
    if (res.message) {
      dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const leftData = leases.map((lease) => {
      return Object.assign({}, lease, {
        farm_lease_cash_rent_data: lease.farm_lease_cash_rent_data.filter((cr) => cr.id !== cashRentId),
      });
    });
    dispatch({ type: LOAD_SUCCESS, leaseCashRent: { data: leftData } });
    return leftData;
  } catch (error) {
    dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getCrpDataByFarmId = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get("/farmLeaseCashCrpTab/getCrpData/" + id);
    if (res.message) {
      dispatch({ type: CRP_LOAD_FAIL, errorMessage: res.message });
      return;
    }

    const list = res.map((item) => {
      const payments = (item.farm_crp_cash_rent_data || []).map((payment) => {
        return Object.assign({}, payment, {
          cash_rent_due: payment.cash_rent_due ? moment(payment.cash_rent_due).utc().format("MM/DD/YYYY") : "",
          dateCashRentPaid: payment.dateCashRentPaid ? moment(payment.dateCashRentPaid).utc().format("MM/DD/YYYY") : "",
        });
      });
      item.farm_crp_cash_rent_data = payments;
      item.crp_expires = item.crp_expires ? moment(item.crp_expires).utc().format("MM/DD/YYYY") : "";
      return item;
    });
    dispatch({ type: CRP_LOAD_SUCCESS, farmCrpData: { data: list } });
    return res;
  } catch (error) {
    dispatch({ type: CRP_LOAD_FAIL, errorMessage: error });
  }
};

export const addCrpData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post("/farmLeaseCashCrpTab/addCrpData/", { data });

    if (res.message) {
      dispatch({ type: CRP_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CRP_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: CRP_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const addNewCRP = (list, farmId) => async (dispatch) =>
  new Promise((resolve, reject) => {
    list.splice(0, 0, { farm_id: farmId, crp_cash_rent_data: [] });

    dispatch({ type: CRP_LOAD_SUCCESS, farmCrpData: { data: list } });
    resolve(list);
  });

export const updateCRPData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put("/farmLeaseCashCrpTab/updateCRPData/", { data });
    if (res.message) {
      dispatch({ type: CRP_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CRP_LOAD_UPDATE_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: CRP_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const deleteCrpData = (id, index) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  let leftCRPs = [];
  const crpData = getState().get("farmLeaseCashCrp").get("farmCrpData");
  const list = crpData.data;

  try {
    if (id) {
      const data = { id: id };
      const res = await api.del("/farmLeaseCashCrpTab/deleteCrpData/", { data });
      if (res.message) {
        dispatch({ type: CRP_LOAD_FAIL, errorMessage: res.message });
        return;
      }
      leftCRPs = list.filter((item) => item.id !== id);
    } else {
      leftCRPs = list.filter((item, key) => key !== index);
    }
    dispatch({ type: CRP_LOAD_SUCCESS, farmCrpData: { data: leftCRPs } });
    return leftCRPs;
  } catch (error) {
    dispatch({ type: CRP_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getCrpCashDataByCrpId = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get("/farmLeaseCashCrpTab/crpCash/getByCrpId/" + id);
    if (res.message) {
      dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CRP_CASH_LOAD_SUCCESS, farmCrpData: res });
    return res;
  } catch (error) {
    dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: error });
  }
};

export const addCrpCashData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post("/farmLeaseCashCrpTab/crpCash/addCrpCashData/", { data });

    if (res.message) {
      dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CRP_CASH_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateCrpCashData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put("/farmLeaseCashCrpTab/crpCash/update/", { data });

    if (res.message) {
      dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }

    dispatch({ type: CRP_CASH_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const deleteCrpcashData = (id) => async (dispatch, getState, api) => {
  const crpData = getState().get("farmLeaseCashCrp").get("farmCrpData");
  const list = crpData.data;
  dispatch({ type: LOAD });
  try {
    const data = { id: id };
    const res = await api.del("/farmLeaseCashCrpTab/crpCash/delete/", { data });
    if (res.message) {
      dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const leftData = list.map((crp) => {
      const payments = crp.farm_crp_cash_rent_data.filter((cr) => cr.id !== id);
      crp.farm_crp_cash_rent_data = payments;
      return crp;
    });
    dispatch({ type: CRP_LOAD_SUCCESS, farmCrpData: { data: leftData } });
    return res;
  } catch (error) {
    dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getCrpCashDataById = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get("/farmLeaseCashCrpTab/crpCash/getById/" + id);
    if (res.message) {
      dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CRP_CASH_LOAD_SUCCESS, farmCrpData: res });
    return res;
  } catch (error) {
    dispatch({ type: CRP_CASH_LOAD_FAIL, errorMessage: error });
  }
};

export const addLeaseData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post("/farmLeaseCashCrpTab/addLeaseData/", { data });

    if (res.message) {
      dispatch({ type: LEASE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LEASE_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LEASE_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateLeaseData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put("/farmLeaseCashCrpTab/updateLeaseData/", { data });
    if (res.message) {
      dispatch({ type: LEASE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LEASE_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LEASE_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const uploadLeaseFile = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post("/farmLeaseCashCrpTab/uploadLeaseFile", { data });
    if (res.message) {
      dispatch({ type: LEASE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LEASE_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LEASE_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const deleteLeaseFile = (file, leases) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const data = { id: file.id };
    const res = await api.del("/farmLeaseCashCrpTab/deleteLeaseFile", { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const list = leases.map((lease) => {
      if (lease.id === Number(file.lease_id)) {
        const uploads = lease.farm_lease_uploads.filter((upload) => upload.id !== file.id);
        lease.farm_lease_uploads = uploads;
      }
      return lease;
    });
    dispatch({ type: LOAD_SUCCESS, leaseCashRent: { data: list } });
    return list;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const addLeaseCashData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post("/farmLeaseCashCrpTab/leaseCash/addLeaseCashData/", { data });

    if (res.message) {
      dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LEASE_CASH_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getLeaseCashDataByLeaseId = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get("/farmLeaseCashCrpTab/leaseCash/getByLeaseId/" + id);
    if (res.message) {
      dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LEASE_CASH_LOAD_SUCCESS, farmCrpData: res });
    return res;
  } catch (error) {
    dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: error });
  }
};

export const getLeaseCashDataById = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get("/farmLeaseCashCrpTab/leaseCash/getById/" + id);
    if (res.message) {
      dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LEASE_CASH_LOAD_SUCCESS, farmCrpData: res });
    return res;
  } catch (error) {
    dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: error });
  }
};

export const updateLeaseCashData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put("/farmLeaseCashCrpTab/leaseCash/update/", { data });
    if (res.message) {
      dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LEASE_CASH_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LEASE_CASH_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getCrpDataById = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get("/farmLeaseCashCrpTab/getCRPDataById/" + id);
    if (res.message) {
      dispatch({ type: CRP_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CRP_LOAD_UPDATE_SUCCESS, farmCrpData: res });
    return res;
  } catch (error) {
    dispatch({ type: CRP_LOAD_FAIL, errorMessage: error });
  }
};

/**
 * Print lease report
 */

export const createPdfLcc = (data) => async (dispatch, getState, api) => {
  dispatch({ type: CREATE_LEASE_LCC });
  try {
    const res = await api.post("/farmLeaseCashCrpTab/create-pdf-lcc", { data });
    if (res.message) {
      dispatch({ type: CREATE_LEASE_LCC_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: CREATE_LEASE_LCC_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: CREATE_LEASE_LCC_FAIL, errorMessage: error.message || error });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/farmLeaseCashCrp.js